import { motion } from "framer-motion";

const ITEMS = [
  {
    time: "6:00 PM",
    label: "Guest Arrival & Welcome",
    note: "Rose petals, sweet aroma & warm smiles",
    icon: "welcome",
  },
  {
    time: "7:00 PM",
    label: "Gol Dhana Ceremony",
    note: "The sacred exchange of sweets & vows",
    icon: "diya",
  },
  {
    time: "7:30 PM",
    label: "Ring Exchange",
    note: "A promise sealed with two golden rings",
    icon: "rings",
  },
  {
    time: "8:00 PM",
    label: "Cake Cutting",
    note: "A sweet celebration of togetherness",
    icon: "cake",
  },
  {
    time: "8:30 PM",
    label: "Dinner & Festivities",
    note: "A feast to bless the new beginning",
    icon: "dinner",
  },
];

const Icon = ({ name }) => {
  const stroke = "#8a6b35";
  const size = 30;
  switch (name) {
    case "welcome":
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
          <path d="M16 5 L20 12 L28 13 L22 19 L23 27 L16 23 L9 27 L10 19 L4 13 L12 12 Z" stroke={stroke} strokeWidth="1.4" strokeLinejoin="round" />
        </svg>
      );
    case "diya":
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
          <path d="M16 4 C16 8 13 10 13 13 C13 16 15 17 16 17 C17 17 19 16 19 13 C19 10 16 8 16 4 Z" stroke={stroke} strokeWidth="1.4" strokeLinejoin="round" fill="rgba(255,220,150,0.4)" />
          <path d="M6 22 Q16 30 26 22 Q22 20 16 20 Q10 20 6 22 Z" stroke={stroke} strokeWidth="1.4" strokeLinejoin="round" fill="rgba(214,199,158,0.4)" />
        </svg>
      );
    case "rings":
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
          <circle cx="12" cy="18" r="7" stroke={stroke} strokeWidth="1.4" />
          <circle cx="20" cy="18" r="7" stroke={stroke} strokeWidth="1.4" />
          <path d="M11 8 L13 5 L15 8 Z" stroke={stroke} strokeWidth="1.2" strokeLinejoin="round" fill="rgba(255,220,150,0.5)" />
          <path d="M19 8 L21 5 L23 8 Z" stroke={stroke} strokeWidth="1.2" strokeLinejoin="round" fill="rgba(255,220,150,0.5)" />
        </svg>
      );
    case "cake":
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
          <path d="M6 26 L6 18 L26 18 L26 26 Z" stroke={stroke} strokeWidth="1.4" strokeLinejoin="round" />
          <path d="M8 18 L8 13 L24 13 L24 18" stroke={stroke} strokeWidth="1.4" strokeLinejoin="round" />
          <path d="M16 13 L16 8" stroke={stroke} strokeWidth="1.4" strokeLinecap="round" />
          <path d="M15 8 Q16 5 17 8" stroke={stroke} strokeWidth="1.4" strokeLinecap="round" fill="rgba(255,180,120,0.6)" />
        </svg>
      );
    case "dinner":
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
          <circle cx="16" cy="18" r="9" stroke={stroke} strokeWidth="1.4" />
          <circle cx="16" cy="18" r="5" stroke={stroke} strokeWidth="1.1" opacity="0.6" />
          <path d="M6 6 L6 14 M10 6 L10 14 M8 6 L8 18" stroke={stroke} strokeWidth="1.4" strokeLinecap="round" />
          <path d="M24 6 Q22 12 24 18 L26 18 L26 6 Z" stroke={stroke} strokeWidth="1.4" strokeLinejoin="round" />
        </svg>
      );
    default:
      return null;
  }
};

export const ScheduleSection = () => (
  <motion.section
    className="sec snap-sec sch-sec"
    data-testid="schedule-section"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8 }}
  >
    <div className="sch-ornament sch-ornament-top">
      <svg width="140" height="18" viewBox="0 0 140 18" fill="none">
        <path d="M4 9 L60 9" stroke="#c9ad63" strokeWidth="1" strokeLinecap="round" />
        <path d="M80 9 L136 9" stroke="#c9ad63" strokeWidth="1" strokeLinecap="round" />
        <path d="M70 3 L74 9 L70 15 L66 9 Z" stroke="#c9ad63" strokeWidth="1.2" fill="rgba(201,173,99,0.15)" strokeLinejoin="round" />
        <circle cx="60" cy="9" r="1.6" fill="#c9ad63" />
        <circle cx="80" cy="9" r="1.6" fill="#c9ad63" />
      </svg>
    </div>

    <div className="sec-title f-corm">Schedule of Events</div>
    <div className="eyebrow f-corm" style={{ marginTop: 10 }}>Sunday, 2nd August 2026</div>

    <div className="sch-timeline" data-testid="schedule-timeline">
      <div className="sch-spine" aria-hidden />

      {ITEMS.map((it, i) => (
        <motion.div
          key={it.time}
          className={`sch-row ${i % 2 === 0 ? "left" : "right"}`}
          data-testid={`timeline-item-${i + 1}`}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.6, delay: i * 0.1 }}
        >
          <div className="sch-node" aria-hidden>
            <div className="sch-node-ring" />
            <div className="sch-node-dot" />
          </div>

          <div className="sch-card">
            <div className="sch-icon"><Icon name={it.icon} /></div>
            <div className="sch-body">
              <div className="sch-time f-corm">{it.time}</div>
              <div className="sch-label f-corm">{it.label}</div>
              <div className="sch-note f-corm">{it.note}</div>
            </div>
          </div>
        </motion.div>
      ))}
    </div>

    <div className="sch-ornament sch-ornament-bot">
      <svg width="140" height="18" viewBox="0 0 140 18" fill="none">
        <path d="M4 9 L60 9" stroke="#c9ad63" strokeWidth="1" strokeLinecap="round" />
        <path d="M80 9 L136 9" stroke="#c9ad63" strokeWidth="1" strokeLinecap="round" />
        <path d="M70 3 L74 9 L70 15 L66 9 Z" stroke="#c9ad63" strokeWidth="1.2" fill="rgba(201,173,99,0.15)" strokeLinejoin="round" />
        <circle cx="60" cy="9" r="1.6" fill="#c9ad63" />
        <circle cx="80" cy="9" r="1.6" fill="#c9ad63" />
      </svg>
    </div>
  </motion.section>
);
